import { render, staticRenderFns } from "./PurchaseOrderDetail.vue?vue&type=template&id=21e82bb4&scoped=true"
import script from "./PurchaseOrderDetail.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderDetail.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseOrderDetail.vue?vue&type=style&index=0&id=21e82bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e82bb4",
  null
  
)

export default component.exports